export const websiteName = 'Ezent';
export const light = 'white';
export const dark = '#020305';
